// Public storefront snapshot; integer cents and exact source option strings.
// Label pricing and flower-jar fulfillment are scoped to the jar-label builder.
// Chrome (10/24) and Gold (10/31) ring variants are live at the Holographic ring prices.
// Flat Gloss and Matte (Josh 10/17) both take the live Economy Standard ring.
// Flower glass: jars-shop.js JARS_DEFAULTS; thresholds count CASES, not jars.
// Command reference/addons.json apply: 4oz wrap 30 + top 30; 150ml wrap 75 + top 30;
// optional lid-wrap application 45 cents. 5ml application is null (wrap seals product).
// 5ml glass (Josh 10/15: same workflow on every jar, 5ml just has no application) keys by jar type; packs of 90/95.
// Full-case rounding follows Command app/pricing.py glass(); spares stay unlabelled.
window.VP_JAR_LABEL_EXTRAS = {
  "fulfillment": {
    "version": 1,
    "sourceRefs": [
      "jars-shop.js:JARS_DEFAULTS",
      "Command/reference/addons.json:apply",
      "Command/reference/volume-pricing.json",
      "Command/app/pricing.py:glass",
      "https://vinylpac.us/products/4oz-gloss-black-glass-jar-w-cr-lid-30-pack-1-25-jar",
      "https://vinylpac.us/products/miron-saturn-150ml-violet-glass-jar-w-cr-lid-30-pack-3-25-jar"
    ],
    "products": {
      "black-4oz": {
        "jarProductId": "black-glass-4oz-cr",
        "jarCaseSize": 32,
        "tiers": [
          {"qty": 1, "priceCents": 125},
          {"qty": 5, "priceCents": 115},
          {"qty": 24, "priceCents": 105},
          {"qty": 44, "priceCents": 95},
          {"qty": 64, "priceCents": 90},
          {"qty": 84, "priceCents": 85},
          {"qty": 104, "priceCents": 80}
        ],
        "applicationUnitCents": 60,
        "lidWrapApplicationCents": 45
      },
      "miron-150ml": {
        "jarProductId": "miron-saturn-150ml-cr",
        "jarCaseSize": 30,
        "tiers": [
          {"qty": 1, "priceCents": 325},
          {"qty": 11, "priceCents": 315},
          {"qty": 21, "priceCents": 305},
          {"qty": 34, "priceCents": 295},
          {"qty": 41, "priceCents": 290}
        ],
        "applicationUnitCents": 105,
        "lidWrapApplicationCents": 45
      },
      "miron-5ml:Eris": {
        "jarProductId": "miron-eris-5ml-cr",
        "jarCaseSize": 90,
        "tiers": [
          {"qty": 1, "priceCents": 170},
          {"qty": 3, "priceCents": 165},
          {"qty": 5, "priceCents": 155},
          {"qty": 53, "priceCents": 150}
        ],
        "applicationUnitCents": null,
        "lidWrapApplicationCents": null
      },
      "miron-5ml:Ceres": {
        "jarProductId": "miron-ceres-5ml",
        "jarCaseSize": 95,
        "tiers": [
          {"qty": 1, "priceCents": 165},
          {"qty": 3, "priceCents": 160},
          {"qty": 5, "priceCents": 150},
          {"qty": 53, "priceCents": 145}
        ],
        "applicationUnitCents": null,
        "lidWrapApplicationCents": null
      }
    }
  },
  "rules": {
    "miron-5ml-ceres": {
      "min": 20,
      "step": 10,
      "discounts": [
        {
          "min": 500,
          "rate": 0.05
        },
        {
          "min": 1000,
          "rate": 0.1
        },
        {
          "min": 5000,
          "rate": 0.15
        }
      ]
    },
    "miron-5ml-eris": {
      "min": 20,
      "step": 10,
      "discounts": [
        {
          "min": 500,
          "rate": 0.05
        },
        {
          "min": 1000,
          "rate": 0.1
        },
        {
          "min": 5000,
          "rate": 0.15
        }
      ]
    },
    "black-4oz": {
      "min": 20,
      "step": 10,
      "discounts": [
        {
          "min": 500,
          "rate": 0.05
        },
        {
          "min": 1000,
          "rate": 0.1
        },
        {
          "min": 5000,
          "rate": 0.15
        }
      ]
    },
    "miron-150ml": {
      "min": 20,
      "step": 10,
      "discounts": [
        {
          "min": 500,
          "rate": 0.05
        },
        {
          "min": 1000,
          "rate": 0.1
        },
        {
          "min": 5000,
          "rate": 0.15
        }
      ]
    }
  },
  "lidWrap": {
    "url": "https://vinylpac.us/products/jar-lid-wrap",
    "variants": [
      {
        "id": "47967372574878",
        "price": 15,
        "options": [
          "Economy",
          "Standard"
        ],
        "available": true
      },
      {
        "id": "47967372607646",
        "price": 30,
        "options": [
          "Standard",
          "Standard"
        ],
        "available": true
      },
      {
        "id": "47967372640414",
        "price": 45,
        "options": [
          "Premium",
          "Standard"
        ],
        "available": true
      },
      {
        "id": "48193711210654",
        "price": 30,
        "options": [
          "Economy",
          "Holographic"
        ],
        "available": true
      },
      {
        "id": "48193711243422",
        "price": 30,
        "options": [
          "Economy",
          "Glitter"
        ],
        "available": true
      },
      {
        "id": "48193711276190",
        "price": 45,
        "options": [
          "Standard",
          "Holographic"
        ],
        "available": true
      },
      {
        "id": "48193711308958",
        "price": 45,
        "options": [
          "Standard",
          "Glitter"
        ],
        "available": true
      },
      {
        "id": "48193711341726",
        "price": 60,
        "options": [
          "Premium",
          "Holographic"
        ],
        "available": true
      },
      {
        "id": "48193711374494",
        "price": 60,
        "options": [
          "Premium",
          "Glitter"
        ],
        "available": true
      },
      {
        "id": "67809326071966",
        "price": 30,
        "options": [
          "Economy",
          "Chrome"
        ],
        "available": true
      },
      {
        "id": "67809326104734",
        "price": 45,
        "options": [
          "Standard",
          "Chrome"
        ],
        "available": true
      },
      {
        "id": "67809326137502",
        "price": 60,
        "options": [
          "Premium",
          "Chrome"
        ],
        "available": true
      },
      {
        "id": "67894668787870",
        "price": 30,
        "options": [
          "Economy",
          "Gold"
        ],
        "available": true
      },
      {
        "id": "67894668820638",
        "price": 45,
        "options": [
          "Standard",
          "Gold"
        ],
        "available": true
      },
      {
        "id": "67894668853406",
        "price": 60,
        "options": [
          "Premium",
          "Gold"
        ],
        "available": true
      }
    ],
    "mainProductId": "miron-150ml",
    "mainOptionNames": [
      "Print Tier",
      "Finish Option"
    ],
    "addonOptionNames": [
      "Tier",
      "Finish"
    ],
    "optionMapping": [
      {
        "mainOptions": [
          "Economical",
          "Gloss"
        ],
        "addonOptions": [
          "Economy",
          "Standard"
        ],
        "addonVariantId": "47967372574878",
        "price": 15
      },
      {
        "mainOptions": [
          "Economical",
          "Matte"
        ],
        "addonOptions": [
          "Economy",
          "Standard"
        ],
        "addonVariantId": "47967372574878",
        "price": 15
      },
      {
        "mainOptions": [
          "Economical",
          "Holographic"
        ],
        "addonOptions": [
          "Economy",
          "Holographic"
        ],
        "addonVariantId": "48193711210654",
        "price": 30
      },
      {
        "mainOptions": [
          "Economical",
          "Glitter"
        ],
        "addonOptions": [
          "Economy",
          "Glitter"
        ],
        "addonVariantId": "48193711243422",
        "price": 30
      },
      {
        "mainOptions": [
          "Standard Tier Embossing",
          "Standard"
        ],
        "addonOptions": [
          "Standard",
          "Standard"
        ],
        "addonVariantId": "47967372607646",
        "price": 30
      },
      {
        "mainOptions": [
          "Standard Tier Embossing",
          "Holographic"
        ],
        "addonOptions": [
          "Standard",
          "Holographic"
        ],
        "addonVariantId": "48193711276190",
        "price": 45
      },
      {
        "mainOptions": [
          "Standard Tier Embossing",
          "Glitter"
        ],
        "addonOptions": [
          "Standard",
          "Glitter"
        ],
        "addonVariantId": "48193711308958",
        "price": 45
      },
      {
        "mainOptions": [
          "Premium Tier Embossing",
          "Standard"
        ],
        "addonOptions": [
          "Premium",
          "Standard"
        ],
        "addonVariantId": "47967372640414",
        "price": 45
      },
      {
        "mainOptions": [
          "Premium Tier Embossing",
          "Holographic"
        ],
        "addonOptions": [
          "Premium",
          "Holographic"
        ],
        "addonVariantId": "48193711341726",
        "price": 60
      },
      {
        "mainOptions": [
          "Premium Tier Embossing",
          "Glitter"
        ],
        "addonOptions": [
          "Premium",
          "Glitter"
        ],
        "addonVariantId": "48193711374494",
        "price": 60
      },
      {
        "mainOptions": [
          "Economical",
          "Chrome"
        ],
        "addonOptions": [
          "Economy",
          "Chrome"
        ],
        "addonVariantId": "67809326071966",
        "price": 30
      },
      {
        "mainOptions": [
          "Standard Tier Embossing",
          "Chrome"
        ],
        "addonOptions": [
          "Standard",
          "Chrome"
        ],
        "addonVariantId": "67809326104734",
        "price": 45
      },
      {
        "mainOptions": [
          "Premium Tier Embossing",
          "Chrome"
        ],
        "addonOptions": [
          "Premium",
          "Chrome"
        ],
        "addonVariantId": "67809326137502",
        "price": 60
      },
      {
        "mainOptions": [
          "Economical",
          "Gold"
        ],
        "addonOptions": [
          "Economy",
          "Gold"
        ],
        "addonVariantId": "67894668787870",
        "price": 30
      },
      {
        "mainOptions": [
          "Standard Tier Embossing",
          "Gold"
        ],
        "addonOptions": [
          "Standard",
          "Gold"
        ],
        "addonVariantId": "67894668820638",
        "price": 45
      },
      {
        "mainOptions": [
          "Premium Tier Embossing",
          "Gold"
        ],
        "addonOptions": [
          "Premium",
          "Gold"
        ],
        "addonVariantId": "67894668853406",
        "price": 60
      }
    ],
    "embossFinishAffectsMapping": false,
    "addOnOnly": true
  },
  "verifiedAt": "2026-09-07T02:49:44Z",
  "sourceUrls": [
    "https://vinylpac.us/products/miron-5ml-jar-labels-top-sticker-perforated-wrap",
    "https://vinylpac.us/products/miron-5ml-jar-labels-top-sticker-perforated-wrap.js",
    "https://vinylpac.us/products/4oz-1-8-oz-jar-labels-top-sticker-jar-wrap",
    "https://vinylpac.us/products/4oz-1-8-oz-jar-labels-top-sticker-jar-wrap.js",
    "https://vinylpac.us/products/miron-150ml-jar-labels-top-sticker-jar-wrap",
    "https://vinylpac.us/products/miron-150ml-jar-labels-top-sticker-jar-wrap.js",
    "https://vinylpac.us/products/jar-lid-wrap.js"
  ],
  "displayPricing": {
    "discountScope": "line",
    "discountedUnitRounding": "ceil-cent",
    "lidWrapDiscounted": false
  },
  "dimensions": {
    "status": "absent-in-verified-sources",
    "unit": null,
    "miron-5ml-ceres": null,
    "miron-5ml-eris": null,
    "black-4oz": null,
    "miron-150ml": null,
    "lidWrap": null
  }
};
